import { apiClient, apiGet, apiPost, apiDelete } from "@/lib/api/client";

const BASE = "/knowledge-graph";

export const knowledgeGraphApi = {
  createRelation: (dto: {
    sourceType: string;
    sourceId: string;
    targetType: string;
    targetId: string;
    relationship: string;
    metadata?: Record<string, unknown>;
  }) =>
    apiPost<{ relation: Record<string, unknown> }>(`${BASE}/relations`, dto),

  createRelations: (relations: Array<{
    sourceType: string;
    sourceId: string;
    targetType: string;
    targetId: string;
    relationship: string;
    metadata?: Record<string, unknown>;
  }>) =>
    apiPost<{ relations: Record<string, unknown>[]; count: number }>(
      `${BASE}/relations/batch`,
      { relations },
    ),

  getRelations: (params?: {
    entityType?: string;
    entityId?: string;
    relationship?: string;
    relations?: string[];
    sortBy?: string;
    order?: "desc" | "asc";
    search?: string;
    page?: number;
    limit?: number;
  }) => {
    const searchParams = new URLSearchParams();
    if (params?.entityType) searchParams.set("entityType", params.entityType);
    if (params?.entityId) searchParams.set("entityId", params.entityId);
    if (params?.relationship) searchParams.set("relationship", params.relationship);
    if (params?.relations?.length) searchParams.set("relations", params.relations.join(","));
    if (params?.sortBy) searchParams.set("sortBy", params.sortBy);
    if (params?.order) searchParams.set("order", params.order);
    if (params?.search) searchParams.set("search", params.search);
    if (params?.page) searchParams.set("page", String(params.page));
    if (params?.limit) searchParams.set("limit", String(params.limit));
    return apiGet<{ data: Record<string, unknown>[]; meta: Record<string, unknown> }>(
      `${BASE}/relations?${searchParams.toString()}`,
    );
  },

  getEntityRelations: (entityType: string, entityId: string, params?: {
    relationship?: string;
    relations?: string[];
    page?: number;
    limit?: number;
  }) => {
    const searchParams = new URLSearchParams();
    if (params?.relationship) searchParams.set("relationship", params.relationship);
    if (params?.relations?.length) searchParams.set("relations", params.relations.join(","));
    if (params?.page) searchParams.set("page", String(params.page));
    if (params?.limit) searchParams.set("limit", String(params.limit));
    return apiGet<{ data: Record<string, unknown>[]; meta: Record<string, unknown> }>(
      `${BASE}/relations/${entityType}/${entityId}?${searchParams.toString()}`,
    );
  },

  getRelatedEntities: (entityType: string, entityId: string, limit?: number) => {
    const searchParams = new URLSearchParams();
    if (limit) searchParams.set("limit", String(limit));
    return apiGet<{ related: Array<{ type: string; id: string; relationship: string; metadata?: Record<string, unknown>; relevance: number }> }>(
      `${BASE}/related/${entityType}/${entityId}?${searchParams.toString()}`,
    );
  },

  getEntityContext: (entityType: string, entityId: string) =>
    apiGet<{ entityType: string; entityId: string; relations: Record<string, unknown>[]; related: Record<string, unknown>[]; stats: Record<string, unknown> }>(
      `${BASE}/context/${entityType}/${entityId}`,
    ),

  deleteRelation: (id: string) =>
    apiDelete<{ message: string }>(`${BASE}/relations/${id}`),

  getStats: () => apiGet<{ totalRelations: number; byType: Array<{ type: string; count: number }>; byEntityType: Array<{ type: string; count: number }> }>(
    `${BASE}/stats`,
  ),

  getRecommendations: (limit?: number) => {
    const searchParams = new URLSearchParams();
    if (limit) searchParams.set("limit", String(limit));
    return apiGet<{ recommendations: Array<{ type: string; id: string; title?: string; relationship: string; metadata?: Record<string, unknown>; relevance: number }> }>(
      `${BASE}/recommendations?${searchParams.toString()}`,
    );
  },
};